// useCurrentUserQuery — load /auth/me through TanStack Query and map
// the response to `CurrentUserView`. Returns `null` data when the
// payload is malformed so the UI can render a signed-out fallback
// without throwing.

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { useUsersApiClient } from '../api/useUsersApiClient';
import { userKeys } from './queryKeys';
import { toCurrentUserView } from './toCurrentUserView';
import type { CurrentUserView } from './types';

export function useCurrentUserQuery(enabled = true): UseQueryResult<CurrentUserView | null> {
  const client = useUsersApiClient();
  return useQuery<CurrentUserView | null>({
    queryKey: userKeys.current(),
    queryFn: async ({ signal }) => {
      const raw = await client.fetchCurrent(signal);
      return toCurrentUserView(raw);
    },
    enabled,
    staleTime: 60_000,
  });
}
